import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { farmKeys, farmPaths } from '../../../common/queries/farms';

// TSS vite/03 — mutaciones de finca del cliente (public-farms.md, Q-120).
// El READ compartido (useClientFarms) vive en common/; las MUTACIONES son de
// esta feature. Patrón canónico: useMutation + invalidateQueries(farmKeys.all)
// en onSuccess → la lista se refresca sola, sin useState de la respuesta.
//
// Las escrituras devuelven OBJETO PLANO (sin envelope) → r.data directo.
// CSRF (X-CSRF-Token) lo pone el api client central; nunca a mano. owner_id/
// status del body los descarta el backend (stripUnknown) — no se envían.
// Errores → ApiError: 400/409 { fields }, 404 finca ajena, 403 CSRF (global).

export function useCreateFarm() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(farmPaths.list(), payload).then((r) => r.data),
        onSuccess: () => qc.invalidateQueries({ queryKey: farmKeys.all }),
    });
}

export function useUpdateFarm(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(farmPaths.detail(id), payload).then((r) => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: farmKeys.detail(id) });
            qc.invalidateQueries({ queryKey: farmKeys.all });
        },
    });
}

export function useDeleteFarm() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(farmPaths.detail(id)).then((r) => r.data),
        onSuccess: () => qc.invalidateQueries({ queryKey: farmKeys.all }),
    });
}
